import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0D1B2A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/eaf2641b549e7c9c1f20a608bd7edb5f.png" 
              alt="متجر" 
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-gray-300 leading-relaxed mb-6">
              متجرك الموثوق للتسوق الإلكتروني، نوفر لك أفضل المنتجات بأسعار تنافسية وجودة عالية
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#D4A84B] rounded-full transition-colors cursor-pointer text-white">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#D4A84B] rounded-full transition-colors cursor-pointer text-white">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#D4A84B] rounded-full transition-colors cursor-pointer text-white">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>روابط سريعة</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  المنتجات
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  الفئات
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  من نحن
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>خدمة العملاء</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  اتصل بنا
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  الأسئلة الشائعة
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  سياسة الإرجاع
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-[#D4A84B] transition-colors cursor-pointer">
                  الشحن والتوصيل
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>تواصل معنا</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl" style={{ color: '#D4A84B' }}></i>
                </div>
                <span className="text-gray-300">الرياض، المملكة العربية السعودية</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-xl" style={{ color: '#D4A84B' }}></i>
                </div>
                <span className="text-gray-300" dir="ltr">+966 50 123 4567</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-xl" style={{ color: '#D4A84B' }}></i>
                </div>
                <span className="text-gray-300">info@dropshop.sa</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <p className="text-gray-300 text-sm">
              © 2024 متجر. جميع الحقوق محفوظة | <a href="https://readdy.ai/?ref=logo" className="hover:text-[#D4A84B] transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
